import {
  colors,
  Icons,
  ImpButton,
  ImpContainer,
  ImpFlex,
  ImpInput,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';
import { useEffect, useState } from 'react';

import { EVENT } from '../../analytics/analyticsConsts';
import { checkEligibility } from '../../api/api';
import { URL } from '../../api/apiConstants';
import {
  setLoading,
  setShowLinkHHScreen,
} from '../../app/applicationScreenSlice';
import { useAppSelector, useImpState } from '../../app/hooks';
import { ANALYTICS } from '../../firebase/firebase';
import {
  noError,
  validateEmail,
  ValidationResponse,
} from '../../utils/validateUtils';

export default function LinkHHAccount() {
  const { language, consumerInfo, merchantData, appScreenState, dispatch } =
    useImpState();
  const [customerEmail, setCustomerEmail] = useState(
    consumerInfo.consumerProfile.email
  );
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [emailVerificationFailure, setEmailVerificationFailure] =
    useState(false);

  const validator: any = useAppSelector((state) => state.validatorSelector);

  useEffect(() => {
    ANALYTICS.logEvent(EVENT.RC_CLUB_PAGE_VIEWED);
  }, []);

  useEffect(() => {
    setDisabledBtn(true);
    if (
      validateEmail(customerEmail) === ValidationResponse.valid &&
      customerEmail !== ''
    ) {
      setDisabledBtn(false);
    }
  }, [customerEmail, validator.emailError]);

  useEffect(() => {
    if (consumerInfo.emailVerificationFailed) {
      setEmailVerificationFailure(true);
    } else {
      setEmailVerificationFailure(false);
    }
  }, [consumerInfo.emailVerificationFailed]);

  useEffect(() => {
    if (appScreenState.eligibilityVerified) {
      dispatch(setLoading(false));
      dispatch(setShowLinkHHScreen(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appScreenState.eligibilityVerified]);

  if (language === null) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  const handleContinueClick = () => {
    dispatch(
      checkEligibility({
        productUUID: merchantData.productUUID,
        email: customerEmail,
      })
    );
  };

  const rcErrorResponse = (ineligible: boolean) => {
    return ineligible
      ? ValidationResponse.invalidHhEmail
      : ValidationResponse.valid;
  };

  const handleRCClubClick = () => {
    window.open(URL.HH_WEBSITE, '_blank');
  };

  const renderInputField = (nonHHEmail: boolean) => {
    return (
      <ImpInput
        label={language.email}
        value={customerEmail}
        id="HHInputField"
        onChange={(e) => setCustomerEmail(e.target.value)}
        showError={!noError.includes(rcErrorResponse(nonHHEmail))}
        errorMessage=""
      />
    );
  };

  return (
    <ImpContainer maxWidth="368px" textAlign="center">
      <ImpFlex fluid direction="column" align="center">
        <ImpSpacer height="xl" />
        <ImpText typography="headline3">{language.linkHHAccountHeader}</ImpText>
        <ImpSpacer height="xs" />
        <ImpText typography="body2" color={colors.content.onSurfaceVariant}>
          {language.linkHHAccountBody1}
        </ImpText>
        <ImpSpacer height="xs" />
        <ImpText typography="body2" color={colors.content.onSurfaceVariant}>
          {language.linkHHAccountBody2}
        </ImpText>
        <ImpSpacer height="xl" />
        {renderInputField(emailVerificationFailure)}
        <ImpSpacer height="xl" />
        <ImpButton
          size="fill"
          variant="primary"
          buttonStyle="branded"
          disabled={disabledBtn}
          onClick={() => {
            ANALYTICS.logEvent(EVENT.RC_CLUB_PAGE_CONTINUE_CLICKED);
            handleContinueClick();
          }}
          state={appScreenState.loading ? 'submitting' : 'enabled'}
        >
          {language.continueBtn}
        </ImpButton>
        <ImpSpacer height="s" />
        <ImpButton
          size="fill"
          variant="tertiary"
          buttonStyle="branded"
          onClick={() => {
            ANALYTICS.logEvent(EVENT.RC_CLUB_PAGE_LINK_CLICKED, {
              link: 'join_the_rc_club',
            });
            handleRCClubClick();
          }}
          color="var(--merchant-color)"
          leadingIcon={Icons.arrowSquareOut}
        >
          {language.joinRCBtn}
        </ImpButton>
        <ImpSpacer height="xl" />
      </ImpFlex>
    </ImpContainer>
  );
}
